window.HFileSize = function(file){
    var self = this;
    var maxSizes = {
        docs: 200,
    };

    self.file = file;

    self.meta = {};
    self.meta.size = Utils.getFileSizeMB(self.file);

    var getMax = function(){
        return maxSizes[self.meta.type];
    };

    self.type = function(type){
        self.meta.type = type;
        return self;
    };

    self.allowed = function(){
        return self.meta.size <= getMax();
    };

    self.showError = function(){
        hAlert($filter("translate")("File is too large"),
               $filter("translate")("The file is "+(self.meta.size).toFixed(2)+
                                    "MB exceeding the maximum file size of "+ getMax() +"MB"));
    };

    return self;
};
